import { IconWeight } from '../../../configs/icons/icons';

export enum IconType {
  Solid = 1,
  Regular = 2,
  Light = 3,
  Duotone = 4,
  Thin = 5
}

export const ICON_TYPE_MAP: Record<IconType, IconWeight> = {
  [IconType.Solid]: 'fill',
  [IconType.Regular]: 'regular',
  [IconType.Light]: 'light',
  [IconType.Duotone]: 'duotone',
  [IconType.Thin]: 'thin'
};
